import { useParams } from "react-router";
import { SessionTable } from "./components/SessionTable";
import { useLazyQuery } from "@apollo/client";
import { GET_COMPANY, GET_LOCATION } from "ft-shared-graphql";
import { useCompany } from "../../context/CompanyContext";
import { useLocation } from "../../context/LocationContext";
import { useEffect, useState } from "react";
import { Header, LoadingWrapper } from "ui";
// import SessionGrid from "./components/SessionGrid";
import { Card, Grid, Paper, Typography } from "@mui/material";
interface SessionsPageProps {
    onBack: () => void;
}
export function SessionsPage({ onBack }: SessionsPageProps) {
    const { id } = useParams()
    const [pageName, setPageName] = useState<string>("");
    const windowLocation = window.location.pathname.includes("/location") ? "location" : window.location.pathname.includes("company") ? "company" : "answers"
    const { setCompany, company } = useCompany();
    const { setLocation, location } = useLocation();
    const [fetchCompany, { loading: loadingCompany, data: dataCompany }] = useLazyQuery(GET_COMPANY);
    const [fetchLocation, { loading: loadingLocation, data: dataLocation }] = useLazyQuery(GET_LOCATION)
    useEffect(() => {
        if (windowLocation === "location" && location?.id != id) {
            fetchLocation({ variables: { id } })
        } else if (windowLocation === "company" && company?.id != id) {
            fetchCompany({ variables: { id } })
        }
    }, [windowLocation])
    useEffect(() => {
        if (dataCompany && windowLocation === "company") {
            setCompany(dataCompany?.company)
            setPageName(`@${dataCompany?.company?.name}`)
        } else if (dataLocation && windowLocation === "location") {
            setLocation(dataLocation?.location)
            setPageName(`@${dataLocation?.location?.name}`)
        }
    }, [dataCompany, dataLocation, windowLocation])
    return (
        <LoadingWrapper loading={!company && !location}>

            <Grid container spacing={2}>

                <Grid size={12}>
                    <Card elevation={4}
                        style={{
                            width: "100%",
                            display: "block", padding: "16px", height: "auto"
                        }}>
                        {/* <Grid container spacing={1}>
                            <Grid size={12}> */}
                        <Paper component="div" variant="outlined">
                            <SessionTable onBack={onBack} />
                        </Paper>
                        {/* </Grid>
                        </Grid> */}
                    </Card>
                </Grid>
                <Grid size={12}>
                    <Card>
                        {/* <SessionGrid /> */}
                    </Card>
                </Grid>
            </Grid>
        </LoadingWrapper >
    )
}